import { DashboardModuleArea, DashboardModuleLayoutWidget, DashboardModuleZoneArea } from '@/modules/dashboard-module/shared/models/dashboard-module.model'
import { uniqueId } from 'lodash'
import { GridItemData } from 'vue-grid-layout'

export interface DashboardViewsUtilitiesAreaViewsInfoWidget extends GridItemData {
    info: DashboardModuleLayoutWidget
}

export interface DashboardViewsUtilitiesAreaViewsAreaState {
    zone: DashboardModuleZoneArea
}
export const initialDashboardViewsUtilitiesAreaViewsAreaState =
    (): DashboardViewsUtilitiesAreaViewsAreaState => ({
        zone: {
            id: uniqueId(),
            area: DashboardModuleArea.UTILITIES,
            options: {
                isWidgetFillToWidth: true
            }
        }
    })
